export enum BOOKING_PRODUCT_INFO {
  TICKET = 'ticket',
  /* TOUR = "tour", */
}
